import ImageOptimizer from '@/components/image-optimizer';
import { cn, formatNumber } from '@/lib/utils';
import { PlanDto, TAGS_SEPARATOR } from '@/services/types/pricing.type';

export default function HourlyRateCard(plan: PlanDto) {
  return (
    <div className="border-stroke-white desktop:p-10 desktop:rounded-xl flex w-full flex-col gap-5 rounded-lg border bg-white p-6">
      <div className="desktop:gap-7 desktop:justify-start desktop:items-start flex items-center justify-center gap-4">
        {/* Yellow box with hours */}
        <div className="desktop:size-[206px] relative aspect-square size-38 shrink-0 overflow-hidden rounded-2xl">
          <ImageOptimizer src={plan.repImagePath} alt="썸네일" fill />
        </div>
        <div
          className={cn(
            'desktop:flex desktop:flex-col desktop:flex-1',
            plan.description ? 'desktop:mt-1.5' : 'desktop:mt-5',
          )}
        >
          <div className="desktop:gap-4 desktop:flex">
            {/** 웹 */}
            <div className="desktop:flex desktop:flex-none typo-40 hidden font-extrabold">
              <span className="text-main-orange">{plan.label}</span>&nbsp;
              <span className="text-black">{plan.subLabel}</span>
            </div>
            {/** 웹 + 모바일 */}
            {plan.tags && plan.tags.length > 0 && (
              <div className="desktop:flex-1 flex flex-wrap gap-1">
                {plan.tags.split(TAGS_SEPARATOR).map((tag, index) => (
                  <div
                    key={index}
                    className="bg-bg-grayblue desktop:h-10 flex h-[35px] items-center justify-center rounded-lg"
                  >
                    <span className="typo-15 text-font-grayblue desktop:typo-16 px-4 text-center font-semibold">
                      {tag}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="desktop:flex desktop:justify-start hidden">
            {plan.description && (
              <p className="typo-24 text-level-4 mt-4 font-semibold">
                {plan.description.replace(/<br\s*\/?>|\n/gi, ' ')}
              </p>
            )}
          </div>
          {/** 웹 */}
          <div
            className={cn(
              'desktop:grid hidden grid-cols-3 gap-11',
              plan.description ? 'mt-10' : 'mt-13',
            )}
          >
            {plan.prices.map((price, index) => (
              <div
                key={index}
                className="flex flex-col items-start justify-between gap-4"
              >
                <span className="typo-26 text-level-2 font-extrabold">
                  {price.label}
                </span>
                <div className="flex items-center justify-center gap-2">
                  <span className="text-main-orange typo-32 font-extrabold">
                    {formatNumber(price.price)}원
                  </span>
                  {price.originPrice && price.originPrice > 0 ? (
                    <span className="text-level-6 typo-20 font-semibold line-through">
                      {formatNumber(price.originPrice)}원
                    </span>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/** 모바일 */}
      {/* Right side content */}
      <div className="desktop:hidden">
        <div className="typo-26 flex flex-wrap items-end justify-center font-extrabold">
          <span className="text-main-orange">{plan.label}</span>&nbsp;
          {plan.code.startsWith('special') ? (
            <span className="typo-18 mb-0.5 font-bold text-black">
              {plan.subLabel}
            </span>
          ) : (
            <span className="text-black">{plan.subLabel}</span>
          )}
        </div>
        {plan.description && (
          <div
            className="typo-16 text-level-4 mt-3 text-center leading-snug font-semibold"
            dangerouslySetInnerHTML={{
              __html: plan.description,
            }}
          ></div>
        )}
      </div>

      {/** 모바일 */}
      {/* Pricing options */}
      <div className="desktop:hidden space-y-3">
        {plan.prices.map((price, index) => (
          <div key={index} className="flex items-center justify-between">
            <span className="typo-18 text-level-2 font-extrabold">
              {price.label}
            </span>
            <div className="flex items-center justify-center gap-1">
              {price.originPrice && price.originPrice > 0 ? (
                <span className="text-level-6 typo-14 font-semibold line-through">
                  {formatNumber(price.originPrice)}원
                </span>
              ) : null}
              <span className="text-main-orange typo-18 font-extrabold">
                {formatNumber(price.price)}원
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
